<!--
 * @Descripttion: 虚拟建造注册账号组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2025-01-17 14:38:08
-->
<template>
  <div class="login-form-wrapper">
    <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
      <a-form-model-item prop="phoneNumber">
        <a-input
          v-model="form.phoneNumber"
          :placeholder="$t('base.pleaseInputPhoneNumber')"
          allow-clear
          autocomplete="new-password"
          hide-button
          @blur="handlePhoneNumberBlur"
          @change="clearUserInfo"
          :disabled="loading"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item prop="userId" v-if="userList.length >= 1">
        <a-select v-model="form.userId" size="large" @change="handleChange" :options="userList"> </a-select>
      </a-form-model-item>

      <!-- <a-form-model-item prop="account">
        <a-input
          v-model="form.account"
          placeholder="请输入账号名"
          allow-clear
          hide-button
          :disabled="loading"
        ></a-input>
      </a-form-model-item> -->
      <a-form-item v-if="userList.length >= 1" field="companyName" style="margin-top: 10px" hide-label>
        <!-- <a-input disabled v-model="form.companyName" allow-clear> </a-input> -->
        <a-select
          v-model="form.companyName"
          :placeholder="$t('base.pleaseInputCompanyName')"
          show-search
          size="large"
          :options="companies.filter((item) => item.label !== '其他')"
          :filter-option="filterCompanies"
          @change="chooseCompany"
        >
        </a-select>
      </a-form-item>
      <a-form-model-item v-else prop="companyName">
        <a-select
          v-model="form.companyName"
          :placeholder="$t('base.pleaseInputCompanyName')"
          show-search
          size="large"
          :options="companies"
          :filter-option="filterCompanies"
          @change="chooseCompany"
        >
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="" prop="otherCompanyName" v-if="getCompanyLabel(form.companyName) === '其他'">
        <a-input v-model="form.otherCompanyName" placeholder="公司完整名称" allow-clear :disabled="loading"></a-input>
      </a-form-model-item>

      <a-form-model-item prop="password">
        <a-input-password
          autocomplete="new-password"
          v-model="form.password"
          :placeholder="$t('base.pleaseInputPassword')"
          allow-clear
          hide-button
        ></a-input-password>
      </a-form-model-item>

      <a-form-model-item prop="code" style="margin-top: 10px">
        <a-input
          class="codeInput"
          style="width: 100%; height: 40px"
          v-model="form.code"
          :placeholder="$t('base.pleaseInputCode')"
          :maxLength="6"
          allow-clear
          hide-button
          :disabled="loading"
        >
          <template #suffix>
            <div
              class="send-code"
              :class="{ disabled: isCountingDown || loading }"
              v-if="!isCountingDown"
              @click="sendCode"
            >
              {{ $t('base.getCode') }}
            </div>
            <div v-else style="width: 100%; height: 100%; font-size: 14px; color: #a2a5ae">
              {{ countdown }}{{ $t('base.afterSecondResend') }}
            </div>
          </template>
        </a-input>
      </a-form-model-item>

      <div class="register-box">
        <div class="register-code">
          <a
            href="https://ucnu9t4fowy8.feishu.cn/wiki/Jr8MwN6SniPn4KkrVQ6cbgMCnmc#share-Rxv5dW7BSoIalXx2QvacUQNvnBg"
            target="_blank"
          >
            {{ $t('base.noCode') }}
          </a>
        </div>
        <div>
          {{ $t('base.haveAccount')
          }}<span class="register-link" @click="skipToLoginPage">{{ $t('base.pleaseLogin') }}</span>
        </div>
      </div>
      <a-button type="primary" class="sbmitBtn" @click="handleSubmit">{{ $t('base.agreeTermsRegister') }}</a-button>
    </a-form-model>
  </div>
</template>

<script>
import { sendCaptchaSignUp, UserRegister, searchCompany, getSecret, getUserInfobyPhone } from '@/api/user'
import jwtDecode from 'jwt-decode'
import aes from '@/utils/aes'

export default {
  data() {
    return {
      newValue: null,
      form: {
        phoneNumber: '', //手机号
        userId: '', //账号
        account: '', //账号
        companyName: undefined, //公司名 // 当做Code用
        otherCompanyName: '', //公司完整名称
        password: '', //密码
        code: '', //验证码
      },
      userList: [
        // { userId: '1008611', label: '1008611', value: '1008611', companyName: '张三' },
        // { userId: '1008612', label: '1008612', value: '1008612', companyName: '李四' },
      ], // 用户列表
      countdown: 0,
      loading: false,
      isSendCode: false, //是否发送过验证码
      companies: [],
      options: [
        {
          value: '选项1',
          label: '黄金糕',
        },
        {
          value: '选项2',
          label: '双皮奶',
        },
        {
          value: '选项3',
          label: '蚵仔煎',
        },
        {
          value: '选项4',
          label: '龙须面',
        },
        {
          value: '选项5',
          label: '北京烤鸭',
        },
      ],
      fetching: false,
      lastFetchId: 0,
      secret: '', // 加密密钥
      timestamp: '',
      currentUserInfo: {}, // 账户信息
      hasUser: false, // 是否已经注册过
    }
  },
  computed: {
    isAgree() {
      return this.$store.getters.LoginInfo.isAgree
    },
    isCountingDown() {
      return this.countdown > 0 || false
    },
    rules() {
      return {
        phoneNumber: [
          { required: true, message: this.$t('base.phoneNotEmpty'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        userId: [
          { required: true, message: this.$t('base.accountNotEmpty'), trigger: 'change' },
          { required: true, message: this.$t('base.accountNotEmpty'), trigger: 'blur' },
        ],
        account: [{ required: true, message: this.$t('base.pleaseInputAccount'), trigger: 'blur' }],
        companyName: [{ required: true, message: this.$t('base.pleaseSelectCompany'), trigger: 'change' }],
        otherCompanyName: [
          { required: true, message: this.$t('base.pleaseInputCompanyName'), trigger: 'blur' },
          { validator: this.validateCompanyName, trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('base.pleaseInputPassword'), trigger: 'blur' },
          { validator: this.validatePassword, trigger: 'blur' },
        ],
        code: [
          { required: true, message: this.$t('base.codeNotEmpty'), trigger: 'blur' },
          { pattern: /^\d{6}$/, message: this.$t('base.codeFormatError'), trigger: 'blur' },
        ],
      }
    },
  },
  async mounted() {
    // select的placeholder 属性失效问题
    document.getElementsByClassName('ant-select-selection__placeholder')[0].style.display = 'block'
    this.getCompanyList()
    this.getSecret()
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('comToken')) {
      const decodedToken = jwtDecode(urlParams.get('comToken'))
      this.form.phoneNumber = decodedToken.phone
    }
  },
  methods: {
    // 获取secret和secretTimestamp
    async getSecret() {
      const res = await getSecret()
      if (res.status === 0) {
        this.secret = res.data.secret
        this.timestamp = res.data.timestamp
      } else {
        Message.error('获取失败')
      }
    },
    clearUserInfo(row) {
      if (row.type == 'click') {
        this.userList = []
        this.form.userId = ''
        this.form.accountName = ''
        this.form.companyName = undefined
        this.form.password = ''
      }
    },
    handlePhoneNumberBlur() {
      setTimeout(() => {
        if (this.form.phoneNumber) {
          this.getUserInfo()
        }
      }, 500)
    },
    // 通过手机号查询基础平台用户信息
    async getUserInfo() {
      const phone = this.form.phoneNumber
      const phoneNumberValidate = /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/
      if (!phoneNumberValidate.test(phone)) return
      this.userList = []
      this.form.userId = ''
      this.form.accountName = ''
      this.hasUser = false
      const res = await getUserInfobyPhone(phone)
      if (res.code == 200) {
        if (res.result.length >= 1) {
          // this.companies = []
          this.form.companyName = ''
          this.userList = res.result.map((item) => {
            return {
              label: item.userId,
              value: item.userId,
              ...item,
            }
          })
          this.form.userId = res.result[0].userId
          // this.companies.push({
          //   label: res.result[0].companyName,
          //   value: res.result[0].companyName,
          //   code: res.result[0].companyCode,
          // })
          this.form.companyName = res.result[0].companyCode
          this.hasUser = true
        } else {
          this.form.userId = ''
          this.form.companyName = undefined
          this.hasUser = false
        }
      } else {
        this.userList = []
        Message.error('获取基础平台用户列表失败')
      }
    },

    // 账号选择调整
    handleChange(value) {
      this.currentUserInfo = this.userList.find((item) => item.label === value)
      this.form.userId = this.currentUserInfo.value
      this.form.companyName = this.currentUserInfo.companyCode
    },

    // 验证手机号
    validatePhone(rule, value, callback) {
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error(this.$t('base.phoneNumberError')))
      } else {
        callback()
      }
    },

    // 验证公司名称
    validateCompanyName(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入完整公司名称'))
      } else if (value.length < 4) {
        callback(new Error('公司名称不能少于4个字符'))
      } else {
        callback()
      }
    },

    // 验证密码
    validatePassword(rule, value, callback) {
      // 密码必须包含大小写字母、数字、特殊字符中的至少三种，且长度不少于8位，只允许ASCII字符
      const passwordValidate =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-])[A-Za-z\d@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-]{8,}$/
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!passwordValidate.test(value)) {
        callback(new Error(this.$t('base.passwordRule', [8])))
      } else {
        callback()
      }
    },

    // 选择公司
    chooseCompany(value) {
      // console.log(value, 'valuevalue',this.form.companyName)
      document.getElementsByClassName('ant-select-selection__placeholder').length &&
        (document.getElementsByClassName('ant-select-selection__placeholder')[0].style.display = 'none')
    },

    // 过滤公司名称
    filterCompanies(inputValue, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
    },

    // 获取验证码
    async sendCode() {
      // 先验证手机号
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(this.form.phoneNumber)) {
        this.$message.warning('请输入正确的手机号！')
        return
      }
      this.loading = true
      try {
        await this.$refs.loginForm.validateField('phoneNumber')
        const res = await sendCaptchaSignUp(this.form.phoneNumber)
        console.log(res, '获取验证码返回信息')
        if (res.code == 200) {
          this.isSendCode = true
          this.$message.success('验证码发送成功！')
          this.startCountdown()
        } else {
          this.$message.error(res.message || '验证码发送失败！')
        }
      } catch (error) {
        // console.log(error, 'error')
        // this.$message.error(error.message || '发送验证码失败')
      } finally {
        this.loading = false
      }
    },

    // 启动倒计时
    startCountdown() {
      const TIME_COUNT = 60
      this.countdown = TIME_COUNT
      const interval = setInterval(() => {
        if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
          this.countdown -= 1
        } else {
          clearInterval(interval)
        }
      }, 1000)
    },

    // 获取公司列表
    async getCompanyList() {
      try {
        const res = await searchCompany({ keyWord: '' })
        console.log(res, '获取公司列表获取公司列表')
        // this.companies = [{ label: '其他', value: '其他', code: 'other' }]
        // res.data.forEach((item) => {
        //   this.companies.push({
        //     label: item.companyName,
        //     value: item.companyName,
        //     code: item.companyCode,
        //   })
        // })
        this.companies = res.data.map((item) => {
          return {
            label: item.companyName,
            value: item.companyCode,
            code: item.companyCode,
          }
        })
      } catch (error) {
        console.error('Get company list error:', error)
        this.$message.error('获取公司列表失败，请重试')
      }
    },

    // 跳转到登录页
    skipToLoginPage() {
      this.$router.push('/login')
    },

    // 提交注册
    async handleSubmit() {
      try {
        await this.$refs.loginForm.validate()
        // if (!this.isSendCode) {
        //   this.$message.error('请先获取验证码')
        //   return
        // }
        if (!this.isAgree) {
          this.$message.error(this.$t('tip.pleaseReadTip'))
          return
        }
        this.loading = true
        // 因为接口数据，公司名称有重复，这样写控制台
        let companyLabel = ''
        this.companies.forEach((item) => {
          if (item.value == this.form.companyName) {
            companyLabel = item.label
          }
        })
        const params = {
          telephone: this.form.phoneNumber,
          verifyCode: this.form.code,
          applyAccount: this.form.userId,
          company: companyLabel === '其他' ? this.form.otherCompanyName : companyLabel,
          companyCode: this.form.companyName,
          userName: this.form.account,
          password: aes.encrypt(this.form.password, this.secret),
          secret: this.secret,
          secretTimestamp: this.timestamp,
        }
        console.log(params, '注册送的参数注册送的参数')
        const res = await UserRegister(params)
        if (res.code === 200) {
          this.$message.success(res.message)
          // 注册成功后延迟跳转到登录页
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500)
        } else {
          this.$message.error(res.message || '注册失败！')
        }
      } finally {
        this.loading = false
      }
    },
    getCompanyLabel(companyCode) {
      const findCompany = this.companies.find((item) => item.value === companyCode)
      return findCompany?.label || ''
    },
    // 重置表单
    resetForm() {
      this.$refs.loginForm.resetFields()
      this.isSendCode = false
      this.countdown = 0
    },
  },

  // 组件销毁前清理定时器
  beforeDestroy() {
    if (this.countdown > 0) {
      clearInterval(this.countdownTimer)
    }
  },
}
</script>

<style lang="less" scoped>
.login-form {
  margin-top: 20px;
  font-size: 18px;

  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input-affix-wrapper {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus,
    &-focused {
      box-shadow: none;
    }

    .ant-input {
      background-color: transparent;
      color: #fff;
    }
    .anticon {
      color: #a2a5ae;
    }
  }

  /deep/.ant-input-password {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    .ant-input {
      background-color: transparent;
      color: #fff;
    }

    .anticon {
      color: #a2a5ae;
    }
  }

  /deep/.ant-input {
    height: 40px;
    background-color: #222222;
    border: none;
    border-radius: 8px;
    color: #fff;
    &:focus {
      box-shadow: none;
    }
    &:hover {
      background-color: #222222;
    }
  }

  /deep/.ant-select {
    .ant-select-selector {
      background-color: #222222 !important;
      border: none !important;
      border-radius: 8px !important;

      .ant-select-selection-item {
        color: #ffffff !important;
      }
    }

    .ant-select-arrow {
      color: #a2a5ae;
    }
  }
  /deep/.ant-select-lg .ant-select-selection--single {
    height: 40px;
    background-color: #222222;
    border: none;
    color: #fff;
    &:hover {
      background-color: #222222;
    }
  }

  /deep/.ant-select-dropdown {
    background-color: #222222;

    /deep/.ant-select-item {
      color: #ffffff;

      &-option-active,
      &-option-selected {
        background-color: #333333;
      }
    }
    /deep/.ant-select-item-option {
      background-color: #222222;
      color: #ffffff;
    }
  }
}
.buttonCodeClass {
  font-size: 18px;
}

.register-box {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
  // bottom: 30px;
  padding: 0px 5px;

  color: #a2a5ae;
  .register-code {
    a {
      color: #ffffff;
    }
  }
  .register-link {
    color: #0166fc;
    cursor: pointer;
    margin-left: 10px;
  }
}

.sbmitBtn {
  width: 360px;
  height: 40px;
  background: #0166fc;
  border-radius: 8px 8px 8px 8px;
}

.codeInput {
  /deep/.anticon-close-circle {
    margin-right: 5px;
  }
}

.send-code {
  cursor: pointer;
  color: #0166fc;
  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

/deep/.ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a2a5ae;
}
</style>
